import React from 'react';
import { motion } from 'framer-motion';
import { LockIcon, ZapIcon, ShieldCheckIcon, InfinityIcon } from 'lucide-react';

// Real Shopify checkout URLs
const SILVER_URL = 'https://e1be42-id.myshopify.com/cart/51493254136106:1';
const PLATINUM_URL = 'https://e1be42-id.myshopify.com/cart/51499875991850:1';
const VIP_URL = 'https://e1be42-id.myshopify.com/cart/51499880972586:1';
const scrollToUpgrades = () => document.querySelector('#upgrades')?.scrollIntoView({
  behavior: 'smooth'
});
export function FinalCTA() {
  return <section id="final-cta" className="relative bg-[#060B18] py-24 overflow-hidden" data-id="element-87">
      {/* Gold radial glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[700px] h-[700px] bg-[#FFB800]/7 rounded-full blur-[160px] pointer-events-none" data-id="element-88" />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[300px] h-[300px] bg-[#FF6B00]/5 rounded-full blur-[80px] pointer-events-none" data-id="element-89" />

      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative" data-id="element-90">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-91">
          <h2 className="font-display font-extrabold text-4xl sm:text-5xl lg:text-6xl text-white mb-2" data-id="element-92">
            Stop Guessing.
          </h2>
          <h2 className="font-display font-extrabold text-4xl sm:text-5xl lg:text-6xl text-gradient-teal mb-6" data-id="element-93">
            Start Growing.
          </h2>

          <p className="text-white/50 text-lg max-w-xl mx-auto mb-10 leading-relaxed" data-id="element-94">
            Join thousands of small business owners who finally understand their numbers.
            Pick the package that fits your goals today.
          </p>

          {/* 3 package quick links */}
          <div className="grid grid-cols-3 gap-3 mb-10 max-w-lg mx-auto" data-id="element-95">
            {[{
            label: 'Silver',
            price: '$59.99',
            url: SILVER_URL,
            accent: '#9CA3AF',
            from: '#4B5563',
            to: '#374151',
            textColor: '#ffffff'
          }, {
            label: 'Platinum',
            price: '$69.99',
            url: PLATINUM_URL,
            accent: '#FFB800',
            from: '#FFB800',
            to: '#FF6B00',
            textColor: '#0D1A35',
            popular: true
          }, {
            label: 'VIP',
            price: '$99.99',
            url: VIP_URL,
            accent: '#b4a0ff',
            from: '#7B2FBE',
            to: '#4F46E5',
            textColor: '#ffffff'
          }].map(pkg => <a key={pkg.label} href={pkg.url} className="relative rounded-xl py-3.5 text-center transition-all duration-300 hover:-translate-y-1 hover:shadow-lg block" style={{
            background: `linear-gradient(135deg, ${pkg.from}, ${pkg.to})`,
            color: pkg.textColor,
            boxShadow: `0 4px 20px ${pkg.accent}20`
          }} data-id="element-96">
                {pkg.popular && <div className="absolute -top-2.5 left-1/2 -translate-x-1/2 text-[8px] font-extrabold uppercase tracking-wider px-2.5 py-0.5 rounded-full whitespace-nowrap" style={{
              background: pkg.from,
              color: '#0D1A35'
            }} data-id="element-97">
                    Popular
                  </div>}
                <p className="font-display font-extrabold text-sm" data-id="element-98">{pkg.label}</p>
                <p className="font-display font-extrabold text-xl" data-id="element-99">{pkg.price}</p>
              </a>)}
          </div>

          {/* Main CTA → scrolls to packages section */}
          <motion.button whileHover={{
          scale: 1.03
        }} whileTap={{
          scale: 0.97
        }} onClick={scrollToUpgrades} className="bg-gradient-gold text-white font-bold text-lg px-12 py-4 rounded-full hover:shadow-2xl hover:shadow-[#FF6B00]/30 transition-all duration-300 mb-8" data-id="element-100">
            Choose My Package →
          </motion.button>

          <div className="flex items-center justify-center flex-wrap gap-4 mb-10" data-id="element-101">
            {[{
            icon: LockIcon,
            label: 'Secure Checkout'
          }, {
            icon: ZapIcon,
            label: 'Instant Download'
          }, {
            icon: ShieldCheckIcon,
            label: '30-Day Guarantee'
          }, {
            icon: InfinityIcon,
            label: 'Lifetime Access'
          }].map(({
            icon: Icon,
            label
          }) => <div key={label} className="flex items-center gap-1.5 text-white/30 bg-white/5 px-3 py-1.5 rounded-full text-xs" data-id="element-102">
                <Icon className="w-3.5 h-3.5" data-id="element-103" />
                <span data-id="element-104">{label}</span>
              </div>)}
          </div>

          <p className="text-white/20 text-xs max-w-md mx-auto leading-relaxed" data-id="element-105">
            This is a digital product delivered via instant download. Results may vary based on individual business circumstances. All purchases backed by our 30-day satisfaction promise.
          </p>
        </motion.div>
      </div>
    </section>;
}